module.exports = __webpack_public_path__ + "img/2.b4340926.jpg";